import { z } from "zod";

export const memberSearchQuerySchema = z
	.object({
		q: z.string().optional(),
		limit: z.coerce.number().int().min(1).max(50).default(10),
	})
	.strict();

export type MemberSearchQueryPayload = z.infer<typeof memberSearchQuerySchema>;
